const initialState = {
  language: 'zh-CN',
  cpcdKey: 'CACHE_ADDRESS',
  orgId: sessionStorage.getItem('x-orgId') || '',
  st: 'n', // 如果是iframe嵌入，是否需要同步父级窗口的token
  bventId: '',
  userInfo: {},
  associatedBventId: '',
  formSetting: {
    tableList: [],
    fieldsObj: {},
    fieldsValues: [],
    shareDataObj: {}
  },
  attendeeSubmitRecord: {
    pageIndex: 1,
    pageSize: 20,
    total: 0, // 参会提交总记录数量
    totalPage: 0, // 总页数
    records: [] // 提交记录集合，item={id: '', name: '', createdDate: '', avatar: ''}
  },
  app: {
    appId: '', // 应用ID
    detail: {
      appCode: '',
      appName: '',
      appIcon: '',
      appDescription: '',
      appType: -1, // 应用类型(1:系统应用 2:组织应用 3:会展应用)
      isExternalStorage: -1 // 是否使用外部存储(0:否 1:是)
    } // 应用详情
  },
  associatedTable: {
    have: false,
    apiInfo: null,
    fields: []
  },
  tipsConfig: {
    submitSuccessCn: '信息已提交成功，感谢您的配合',
    submitSuccessEn: 'Information submitted successfully, thank you for your cooperation.',
    submitSuccessButtonCn: '返回',
    submitSuccessButtonEn: 'Go back',
    lotteryBtnCn: '参与抽奖',
    lotteryBtnEn: 'Start the lottery',
    needApprovalCn: '您提交的数据需要审核，请耐心等待',
    needApprovalEn: 'Your submitted data requires review. Please wait patiently.',
    unregisteredCn: '表单开启了仅参会人员可提交，请先报名',
    unregisteredEn: 'The form has been set to allow only participants to submit. Please register first.',
    unfinishedCn: '您的报名尚未完成，请先完成报名',
    unfinishedEn: 'Your registration is not yet complete. Please finish your registration first.',
    regReviewingCn: '您的报名正在审核中，请耐心等待',
    regReviewingEn: 'Your registration is under review. Please wait patiently.',
    formUnavailableCn: '该表单已关闭，无法提交',
    formUnavailableEn: 'This form is closed and cannot be submitted.',
    formEntryTitleCn: '提交记录',
    formEntryTitleEn: 'Form Entry',
    auditNotApprovedCn: '审核未通过',
    auditNotApprovedEn: 'Audit Not Approved',
    modifyRequestedCn: '需修改信息',
    modifyRequestedEn: 'Modify Requested',
    awaitingApprovalCn: '待审核',
    awaitingApprovalEn: 'Awaiting Approval',
    noApprovalNeededCn: '无需审核',
    noApprovalNeededEn: 'No Approval Needed',
    auditApprovedCn: '审核通过',
    auditApprovedEn: 'Audit Approved',
    recordListCn: '',
    recordListEn: '',
    submitGoonCn: '提交并继续',
    submitGoonEn: 'Submit and continue'
  },
  channelForm: {
    paper: {}, // 论文数据
    firstAuthor: {}, // 第一作者
    otherAuthor: {} // 其他作者
  },
  channelDetail: {},
  relationId: '' // 关联参会人/团体
}

export default initialState
